<template>
  <div>
    <layoutContainer activityFrom="咨询列表页">
      <!-- <p>queryParams:{{ queryParams }}</p> -->
      <div class="search-header">
        <div v-if="SearchInput" class="SearchInput">
          {{ SearchInput }}
          <i @click="clearSearchInput" :class="'el-icon-error close-icon'"></i>
        </div>
        <checkRadioGroup
          title="职业"
          :list="EmployeeOccupationList"
          :activeIndex.sync="queryParams.occupationId"
          keyname="name"
        ></checkRadioGroup>
        <checkRadioGroup
          title="公司"
          :list="FamousInternetCompanyShortNameList"
          :activeIndex.sync="queryParams.famousCompanyShortName"
          keyname="shortName"
          emitKeyName="shortName"
        >
        </checkRadioGroup>
        <!-- <checkRadioGroup
            title="职业"
            :list="EmployeeOccupationList"
            :activeIndex.sync="queryParams.occupation"
            keyname="name"
          ></checkRadioGroup>
          <checkRadioGroup
            title="公司"
            :list="FamousInternetCompanyShortNameList"
            :activeIndex.sync="queryParams.famousCompanyShortName"
            keyname="shortName"
            emitKeyName="shortName"
          >
          </checkRadioGroup>
           -->
        <checkRadioGroupNew
          title="所在地区"
          :list="area_list.base"
          :activeItem="area_list.findActiveParent(queryParams.areaId)"
          :selectCategoryName="area_list.findCheckedNameById(queryParams.areaId)"
          :activeIndex.sync="queryParams.areaId"
          keyname="name"
          :areaLevel="true"
        ></checkRadioGroupNew>
        <checkRadioGroup
          title="排序"
          :list="orderList"
          :activeIndex.sync="queryParams.orderType"
          keyname="name"
          :hideAll="true"
        >
        </checkRadioGroup>

        <!-- checkRadioGroup(title="排序"
      :list="orderList"
      :activeIndex.sync="queryParams.order"
      :hideAll="true"
      keyname="name"
    ) -->
      </div>

      <div class="conpany-list-box">
        <template v-if="companyList.length === 0">
          <div class="empty-img">
            <img class="empty" src="@/assets/listempty.png" alt="暂无数据" />
          </div>
        </template>
        <div v-else>
          <div class="card-box" v-for="(item, i) in companyList" :key="i">
            <personalCard
              v-if="item"
              :cardItem="item"
              :consultStatus="consultStatus"
              @appointmentOpen="handleDialogOpen"
              @updateList="getConsult"
            ></personalCard>
          </div>
        </div>

        <consultStatus
          class="consult-status"
          :consulterTotal="consulterTotal"
          :consultantTotal="consultantTotal"
          :is-loading="loading"
          @consulterClick="consulterClick"
          @openSuccess="handleOpenSuccess"
          ref="consultStatusRef"
        ></consultStatus>
      </div>
      <div class="right"></div>
      <center class="pagination-box">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="queryParams.page"
          :page-size="12"
          :total="queryParams.total"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          @current-change="currentChange"
        >
        </el-pagination>
      </center>
    </layoutContainer>
    <appointmentDialog
      :visible="showAppointmentDialog"
      @close="handleDialogClose"
      @submit="handleDialogSubmit"
      :consultantId="consultantId"
    ></appointmentDialog>

    <followListDialog
      :visible="showFollowDialog"
      @update:visible="showFollowDialog = $event"
      @unfollowSuccess="handleUnfollowSuccess"
      :employeeId="UserInfo.employeeId"
    ></followListDialog>

    <fansListDialog
      :visible="showFansDialog"
      @update:visible="showFansDialog = $event"
      @removeFansSuccess="handleRemoveFansSuccess"
      :employeeId="UserInfo.employeeId"
    ></fansListDialog>
  </div>
</template>

<script>
import {getEmployeeListApi, getConsultAppointmentListApi} from '../../api/counsult'
import {mapState} from 'vuex'
import {checkedDeepFormat} from '../../utils/findQueryName'
import personalCard from './personalCard.vue'
import consultStatus from './consultStatus.vue'
import appointmentDialog from './appointmentDialog.vue'
import followListDialog from './followListDialog.vue'
import fansListDialog from './fansListDialog.vue'

// 常量配置
const DEFAULT_QUERY_PARAMS = {
  areaId: '',
  orderType: 0,
  content: '',
  occupationId: 0,
  famousCompanyShortName: '',
  showCurrentUserData: 0,
  showCollection: 0,
  pageNum: 1,
  domain: 0,
  queryType: 0
}

const ORDER_LIST = [
  {
    name: '推荐',
    id: 1
  },
  {
    name: '最新',
    id: 2
  }
]

const QUERY_TYPE_MAP = {
  consulter: 1,
  consultant: 2,
  all: 3
}

export default {
  name: 'ConsultingService',
  components: {
    personalCard,
    consultStatus,
    appointmentDialog,
    followListDialog,
    fansListDialog
  },
  computed: {
    ...mapState([
      'UserInfo',
      'AreaList',
      'BusinessList',
      'CompanyList',
      'EmployeeDomainList',
      'EducationList',
      'EmployeeOccupationList',
      'EmployeeDomainClassList',
      'EmployeeOccupationDomainClassRelationList',
      'SearchInput',
      'FamousInternetCompanyShortNameList'
    ]),
    area_list() {
      return checkedDeepFormat(this.AreaList) || {}
    },
    isUpdate() {
      return this.consultStatus === 'consulter' || this.consultStatus === 'consultant' || this.consultStatus === 'all'
    },
    // 计算属性：构建API请求参数
    apiParams() {
      const {
        occupationId,
        areaId,
        famousCompanyShortName,
        pageNum,
        size,
        queryType,
        orderType,
        showCollection,
        showCurrentUserData
      } = this.queryParams
      const params = {pageNum}

      if (size) params.size = size
      if (occupationId) params.occupationId = occupationId
      if (areaId) params.areaId = areaId
      if (famousCompanyShortName) params.famousCompanyShortName = famousCompanyShortName
      if (queryType) params.queryType = queryType
      if (orderType) params.orderType = orderType
      if (this.SearchInput) params.content = this.SearchInput
      if (showCollection) params.showCollection = showCollection
      if (showCurrentUserData) params.showCurrentUserData = showCurrentUserData

      return params
    }
  },
  data() {
    return {
      companyList: [],
      companyNameList: [],
      hoverList: [],
      queryParams: {
        ...DEFAULT_QUERY_PARAMS,
        page: 1,
        total: 0,
        size: 12 // 默认每页显示10条
      },
      consultantTotal: 0, // 预约我的
      consulterTotal: 0, // 我的预约
      orderList: ORDER_LIST,
      isActiveType: false,
      consultStatus: '',
      showAppointmentDialog: false,
      consultantId: 0,
      loading: false,
      showFollowDialog: false,
      showFansDialog: false
    }
  },
  created() {
    this.initData()
  },
  methods: {
    // 初始化数据
    initData() {
      this.companyNameList = this.EmployeeDomainClassList
      const {id} = this.$route.query
      if (id) {
        this.queryParams.domain = id
      }
      this.fetchData()
    },

    // 统一的数据获取方法
    async fetchData() {
      if (this.loading) return

      this.loading = true
      try {
        const apiMethod = ['consulter', 'consultant', 'all'].includes(this.consultStatus)
          ? getConsultAppointmentListApi
          : getEmployeeListApi
        const res = await apiMethod(this.apiParams)

        this.handleApiResponse(res)
      } catch (error) {
        console.error('获取数据失败:', error)
        // this.$message.error(error.msg)
      } finally {
        this.loading = false
      }
    },

    // 处理API响应
    handleApiResponse(res) {
      const {records, current, total, size, consultantTotal, consulterTotal, showCurrentUserData} = res.data
      this.companyList = [...records]
      this.queryParams.page = current
      this.queryParams.pageNum = current // 同步更新pageNum，确保与API返回的页码一致
      this.queryParams.total = total
      const isHas = ['consulter', 'consultant', 'all'].includes(this.consultStatus)
      if (!isHas) {
        this.consultantTotal = consultantTotal
        this.consulterTotal = consulterTotal
      }
      this.showCurrentUserData = showCurrentUserData
    },

    // 获取员工列表（保持向后兼容）
    getEmployeeList() {
      this.consultStatus = ''

      this.fetchData()
    },

    // 获取咨询列表
    getConsult() {
      this.fetchData()
    },

    // 清除搜索输入
    clearSearchInput() {
      this.$store.commit('ChangeSearchInput', '')
    },

    // 选择悬停列表
    selectHoverLsit(id) {
      this.companyNameList = this.EmployeeDomainList
      this.hoverList = []
      this.queryParams.domain = id
    },

    // 取消悬停列表
    cancalHoverList() {
      this.queryParams.domain = ''
      const relationId = this.EmployeeOccupationDomainClassRelationList.find(
        item => item.occupationId === this.queryParams.occupation
      )?.domainClassId

      this.companyNameList = relationId
        ? this.EmployeeDomainClassList.filter(item => item.id === relationId)
        : this.EmployeeDomainClassList

      this.hoverList = this.EmployeeDomainList.filter(item => item.classId === relationId)
    },

    // 改变悬停列表
    changeHoverList(id) {
      this.hoverList = this.EmployeeDomainList.filter(item => item.classId === id)
    },

    // 分页变化
    currentChange(val) {
      // this.companyList = []
      this.queryParams.page = val
      this.queryParams.pageNum = val // 同步更新pageNum，确保API请求使用正确的页码
      this.fetchData()
    },

    // 每页条数变化
    handleSizeChange(val) {
      // this.companyList = []
      this.queryParams.size = val
      this.queryParams.page = 1 // 切换每页条数时重置到第一页
      this.queryParams.pageNum = 1
      this.fetchData()
    },

    // 咨询者点击
    consulterClick(type, index) {
      if (this.loading) return
      this.queryParams.showCurrentUserData = 0
      this.queryParams.showCollection = 0
      if (type === 'guanzhu') {
        // 打开关注列表弹窗
        this.showFollowDialog = true
        this.businessType = type
        return
      }
      if (type === 'fans') {
        // 打开粉丝列表弹窗
        this.showFansDialog = true
        return
      }
      if (index === -1) {
        this.companyList = []
        // 获取全部
        // 刷新数据
        this.queryParams.showCollection = 0
        this.queryParams.showCurrentUserData = 0
        this.filterQueryParams()
        this.resetToListType(true)
        this.getEmployeeList()
        return
      }
      if (type === 'consulter' || type === 'consultant' || type === 'all') {
        // 我的预约type === 'consulter'
        // 预约我的consultant
        this.companyList = []
        this.queryParams.queryType = QUERY_TYPE_MAP[type]
        this.consultStatus = type
        this.clearSearchAndFilters(false)
        this.getConsult()
        return
      }
      if (type === 'detail') {
        // 清空搜索内容和筛选条件，但不重置UI状态
        this.consultStatus = type
        this.companyList = []
        this.queryParams.showCurrentUserData = 1
        this.clearSearchAndFilters(false)
        this.getEmployeeList()

        return
      }
      if (type === 'col') {
        this.queryParams.showCurrentUserData = 0
        // 清空搜索内容和筛选条件，但不重置UI状态
        this.clearSearchAndFilters(false)
        this.companyList = []
        this.queryParams.showCollection = 1
        this.getEmployeeList()
        this.consultStatus = type
        return
      }

      this.consultStatus = type

      this.getConsult()
    },
    // 预约我的和我的预约接口请求
    // getAppointmentList(type) {
    //   this.queryParams.showCollection = 0
    //   this.getEmployeeList()
    //   return
    // },

    // 处理弹窗关闭
    handleDialogClose() {
      this.showAppointmentDialog = false
    },

    // 处理弹窗打开
    handleDialogOpen(val) {
      this.consultantId = val.consultantId
      this.showAppointmentDialog = true
    },

    // 处理弹窗提交
    handleDialogSubmit(formData) {
      this.showAppointmentDialog = false
      // 可以在这里添加提交成功后的逻辑，比如刷新列表
      this.fetchData()
    },

    // 更新公司名称
    updateCompanyName() {
      const company = this.CompanyList.find(item => item.id === this.queryParams.companyNameId)
      this.queryParams.companyName = company?.shortName || ''
    },
    // 处理开通成功事件
    handleOpenSuccess() {
      // 刷新用户信息
      // this.$store.dispatch('ChangeUserInfoActions')
      // // 刷新列表数据
      // this.fetchData()
    },

    // 处理取消关注成功事件
    handleUnfollowSuccess() {
      // 刷新列表数据
      this.fetchData()
    },

    // 处理移除粉丝成功事件
    handleRemoveFansSuccess() {
      // this.showFansDialog = false
      // 刷新列表数据
      this.fetchData()
    },
    filterQueryParams() {
      this.queryParams.showCollection = 0
      this.queryParams.showCurrentUserData = 0
      this.queryParams.occupationId = 0
      this.queryParams.famousCompanyShortName = ''
      this.queryParams.occupationId = 0
      this.queryParams.pageNum = 1
      this.$refs.consultStatusRef.resetActive()
    },
    // 重置列表类型为个人信息列表
    resetToListType(resetUI = true) {
      this.companyList = []
      this.consultStatus = ''
      if (resetUI && this.$refs.consultStatusRef) {
        this.$refs.consultStatusRef.resetActive()
      }
    },

    // 清空搜索内容和筛选条件
    clearSearchAndFilters(resetUI = true) {
      // 只有在特殊状态下才设置内部更新标志
      if (this.consultStatus && !resetUI) {
        this.isInternalUpdate = true
      }

      // 清空搜索内容
      this.$store.commit('ChangeSearchInput', '')

      // 重置筛选条件到默认值
      this.queryParams.occupationId = 0
      this.queryParams.famousCompanyShortName = ''
      this.queryParams.areaId = ''
      this.queryParams.domain = 0
      this.queryParams.orderType = 0
      this.queryParams.pageNum = 1
      this.queryParams.page = 1

      // 根据参数决定是否重置UI状态
      if (resetUI && this.$refs.consultStatusRef) {
        this.$refs.consultStatusRef.resetActive()
      }

      // 重置内部更新标志
      this.$nextTick(() => {
        this.isInternalUpdate = false
      })
    }
  },
  watch: {
    // 路由查询参数变化
    '$route.query': {
      immediate: true,
      handler() {
        const query = this.$route.query
        this.queryParams.occupation = query.occupation_id ? Number(query.occupation_id) : 0
        this.queryParams.domain = query.proficient_domain_id ? Number(query.proficient_domain_id) : 0
        this.queryParams.famousCompanyShortName = query.famous_company_id || ''
      }
    },
    'queryParams.domain'(val) {
      // this.filterQueryParams()
      if (val && this.isUpdate) {
        this.queryParams.pageNum = 1
        this.resetToListType()
      }
      this.fetchData()
    },
    // 公司筛选
    'queryParams.famousCompanyShortName'(val) {
      if (val && this.isUpdate) {
        this.queryParams.pageNum = 1
        this.resetToListType()
      }
      this.fetchData()
    },
    'queryParams.areaId'(val) {
      // 情况其他请求参数
      // this.filterQueryParams()
      // if()
      // 如果选中了我的预约，或者选中了预约我的按钮，重置按钮状态，
      if (val && this.isUpdate) {
        this.queryParams.pageNum = 1
        this.resetToListType()
      }
      this.fetchData()
    },
    'queryParams.orderType'(val) {
      if (val && this.isUpdate) {
        this.queryParams.pageNum = 1
        this.resetToListType()
      }
      this.fetchData()
    },
    'queryParams.occupationId'(val) {
      if (val && this.isUpdate) {
        this.queryParams.pageNum = 1
        this.resetToListType()
      }
      this.fetchData()
    },

    // 搜索输入变化
    SearchInput(val) {
      if (val && this.isUpdate) {
        this.queryParams.pageNum = 1
        this.resetToListType()
      }
      this.fetchData()
    },

    // 员工领域分类列表变化
    EmployeeDomainClassList() {
      this.companyNameList = this.EmployeeDomainClassList
    }
  }
}
</script>

<style lang="scss" scoped>
.search-header {
  background: #fff;
  margin: 15px 0;
  padding: 10px 0;
}

.conpany-list-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;

  > :nth-child(4n) {
    margin-left: 20px;
  }

  // > :nth-child(4n-3) {
  //   // margin-right: 20px;
  // }
  .empty-img {
    margin: 0 auto;
    overflow: hidden;
  }

  .empty {
    width: 600px;
    display: block;
    margin: 80px auto;
  }
}
.card-box {
  margin-bottom: 15px;
}

.SearchInput {
  display: inline-block;
  margin: 15px 0 15px 160px;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  background: #5ad3cd;
  color: #fff;
  border-radius: 4px;
  position: relative;

  > i {
    position: absolute;
    color: #666666;
    font-size: 20px;
    right: -30px;
    top: 8px;
    cursor: pointer;

    &:hover {
      color: #333;
    }
  }
}
.consult-status {
  margin-left: 23px;
}
.pagination-box {
  margin-top: 10px;
}
</style>
